import { render, staticRenderFns } from "./BooleanAnonymisationField.vue?vue&type=template&id=12d8af5a&"
import script from "./BooleanAnonymisationField.vue?vue&type=script&lang=ts&"
export * from "./BooleanAnonymisationField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports